export * from 'SourceComponent/Router/Router.config';

export const MY_BITCASH = 'MY_BITCASH';
export const CORPORATE_ACCOUNT = 'CORPORATE_ACCOUNT';
export const CUSTOMER_WINNER = 'CUSTOMER_WINNER';
export const MY_SUBSCRIPTION = 'MY_SUBSCRIPTION';
export const MY_SAVED_CARD = 'MY_SAVED_CARD';
